webpackJsonp([72776394686286],{

/***/ 56:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var days = ['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT'];
	
	exports.default = function (_ref) {
	  var date = _ref.date;
	  return _react2.default.createElement(
	    'span',
	    null,
	    date.getFullYear(),
	    '.',
	    date.getMonth() + 1,
	    '.',
	    date.getDate(),
	    '\xA0',
	    days[date.getDay()]
	  );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 95:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/1.2767ca4a.jpg";

/***/ }),

/***/ 160:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.news = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactI18next = __webpack_require__(8);
	
	var _reactHelmet = __webpack_require__(10);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _Header = __webpack_require__(9);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _PrettyDate = __webpack_require__(56);
	
	var _PrettyDate2 = _interopRequireDefault(_PrettyDate);
	
	var _ = __webpack_require__(95);
	
	var _2 = _interopRequireDefault(_);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var news = exports.news = [{
	  publishedAt: new Date('2019/01/01'),
	  catch: _2.default,
	  href: '/news/2019/01/01',
	  title: 't1',
	  description: 'd1'
	}];
	
	var NewsLink = function NewsLink(_ref) {
	  var news = _ref.news,
	      t = _ref.t;
	  return _react2.default.createElement(
	    'div',
	    { className: 'news-link' },
	    _react2.default.createElement('a', { className: 'news-photo', style: { backgroundImage: 'url(' + news.catch + ')' }, href: news.href }),
	    _react2.default.createElement(
	      'div',
	      { className: 'news-link-wrapper' },
	      _react2.default.createElement(
	        'div',
	        { className: 'news-link-date' },
	        _react2.default.createElement(_PrettyDate2.default, { date: news.publishedAt })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'news-link-title' },
	        t(news.title)
	      ),
	      _react2.default.createElement('div', { className: 'news-link-splitter' }),
	      _react2.default.createElement(
	        'div',
	        { className: 'news-link-desc' },
	        t(news.description)
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'news-link-more' },
	        _react2.default.createElement(
	          'a',
	          { href: news.href },
	          'READ MORE'
	        )
	      )
	    )
	  );
	};
	
	var News = (0, _reactI18next.translate)('news')(function (_ref2) {
	  var t = _ref2.t;
	  return _react2.default.createElement(
	    'div',
	    { id: 'news' },
	    _react2.default.createElement(_Header2.default, { current: 'news' }),
	    _react2.default.createElement(
	      'div',
	      { className: 'container' },
	      _react2.default.createElement(
	        'div',
	        { className: 'col1 col-pad1' },
	        _react2.default.createElement(
	          'h1',
	          { className: 'page-title' },
	          'News'
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'col3 news-list' },
	        news.map(function (news) {
	          return _react2.default.createElement(NewsLink, { key: news.href, news: news, t: t });
	        })
	      )
	    )
	  );
	});
	
	exports.default = function () {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_reactHelmet2.default, {
	      meta: [{ name: 'description', content: 'Babels News' }, { property: 'og:title', content: 'Babels News' }, { property: 'og:url', content: 'https://babels.co/news' }, { property: 'og:image', content: 'https://dummyimage.com/600x400/000/fff' }, { property: 'og:image:width', content: '600' }, { property: 'og:image:height', content: '400' }, { property: 'og:description', content: 'Babels News' }, { name: 'twitter:card', content: 'summary_large_image' }, { name: 'twitter:site', content: '@null' }, { name: 'twitter:creator', content: '@null' }]
	    }),
	    _react2.default.createElement(News, null)
	  );
	};

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-news-js-99e4c0d7f929f510fc0a.js